import { FadeWrapper } from '../FadeWrapper';

export const Present = () => (
    <FadeWrapper>
      <div className="career-era">
        <p>
          Ejerciente como abogado, asistiendo a clientes a nivel judicial y
          extrajudicial en todo tipo de asuntos Jurídicos, con despacho propio
          en Madrid y Mallorca.
        </p>
        <p>
          Colaborador de diversas entidades de asesoramiento{' '}
          <strong> fiscal, contable y laboral </strong> españolas y alemanas.
        </p>
      </div>
    </FadeWrapper>
  );
